type TranslateFn = (key: string, ...args: unknown[]) => unknown

interface TranslateComposer {
    t: TranslateFn
    locale: { value: string }
    messages: { value: Record<string, Record<string, unknown>> }
}

/**
 * Wraps a vue-i18n composer's `t` so a message that fails to compile at
 * runtime (e.g. an un-escaped `{{placeholder}}`, which vue-i18n reads as an
 * illegal nested placeholder) falls back to the raw, uncompiled message
 * instead of throwing and crashing whatever component called `t()`.
 */
export function withTranslationFallback (composer: TranslateComposer): TranslateFn {
    const compiledT = composer.t

    return function safeT (key, ...args) {
        try {
            return compiledT.apply(composer, [ key, ...args ])
        } catch (error) {
            console.error(`[i18n] Failed to compile translation for "${key}"`, error)
            const raw = composer.messages.value?.[composer.locale.value]?.[key]
            return typeof raw === 'string' ? raw : key
        }
    }
}
